import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowUpRight } from "lucide-react";

export default function StickyBar({ content }) {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const formUrl = content?.workshop_form_url;

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 650);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const show = visible && !dismissed && !!formUrl;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 inset-x-0 z-40"
          data-testid="sticky-register-bar"
        >
          <div className="bg-navy/95 backdrop-blur-xl border-t border-white/10 shadow-2xl">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
              <div className="flex items-center gap-3 min-w-0">
                <span className="relative flex h-2.5 w-2.5 shrink-0">
                  <span className="absolute inline-flex h-full w-full rounded-full bg-cherry opacity-75 animate-ping" />
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-cherry" />
                </span>
                <p className="hidden md:block text-sm font-sans text-white/80 truncate" data-testid="sticky-bar-title">
                  Mastering Mendeley · 21–22 Oct · Live on Google Meet
                </p>
                <p className="flex items-baseline gap-2 shrink-0">
                  <span className="font-serif text-xl sm:text-2xl font-bold text-white" data-testid="sticky-bar-price">
                    {content?.workshop_price_current || "₹499"}
                  </span>
                  <span className="text-xs sm:text-sm font-sans text-white/40 line-through">
                    {content?.workshop_price_future || "₹1,499"}
                  </span>
                  <span className="hidden sm:inline text-[10px] font-mono uppercase tracking-widest text-cherry">
                    First Batch
                  </span>
                </p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <a
                  href={formUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="sticky-bar-register-button"
                  className="group inline-flex items-center gap-2 bg-cherry hover:bg-[#B81919] text-white text-sm font-medium px-5 sm:px-6 py-2.5 rounded-full transition-colors duration-300"
                >
                  Register Now
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
                <button
                  onClick={() => setDismissed(true)}
                  data-testid="sticky-bar-close"
                  className="p-2 text-white/50 hover:text-white transition-colors"
                  aria-label="Dismiss"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
